// extracted by mini-css-extract-plugin
export var body = "Z_g";
export var footer = "Z_dc";
export var footerText = "Z_cl";
export var section = "Z_b";
export var title = "Z_f";